// extracted by mini-css-extract-plugin
module.exports = {"modal":"ActivePrograms_modal__rxoN8","paper":"ActivePrograms_paper__1u81u"};